// Copyright (c) 2020 embyt GmbH. All rights reserved.
// Author: Roman Morawek

import * as React from "react";
import { connect } from "react-redux";
import { FormattedMessage } from "react-intl";

import { DataState } from "types";
import { IAction } from "actions";
import { IState } from "states/states";

interface ISaveFeedbackExtProps {
  dataState: DataState;
  className?: string;
  lastError?: string | string[];
  hideDirty?: boolean;
}

interface ISaveFeedbackProps {}

const mapStateToProps = (state: IState, ownProps: ISaveFeedbackExtProps) => {
  const props: ISaveFeedbackProps = {};
  return props;
};

interface ISaveFeedbackDispatch {}

const mapDispatchToProps = (dispatch: (action: IAction<any>) => void) => {
  const dispatchProps: ISaveFeedbackDispatch = {};
  return dispatchProps;
};

export class SaveFeedbackComponent extends React.Component<
  ISaveFeedbackProps & ISaveFeedbackExtProps & ISaveFeedbackDispatch
> {
  public render() {
    if (this.props.dataState === DataState.DIRTY && !this.props.hideDirty) {
      return (
        <div className={`alert alert-warning ${this.props.className ?? ""}`}>
          <FormattedMessage id="Data modified." />
        </div>
      );
    } else if (this.props.dataState === DataState.SAVE_REQ) {
      return (
        <div className={`alert alert-success ${this.props.className ?? ""}`}>
          <FormattedMessage id="Saving data..." />
        </div>
      );
    } else if (this.props.dataState === DataState.SAVE_SUCC) {
      return (
        <div className={`alert alert-success ${this.props.className ?? ""}`}>
          <FormattedMessage id="Sucessfully saved data." />
        </div>
      );
    } else if (this.props.dataState === DataState.SAVE_FAIL) {
      if (this.props.lastError) {
        const errString = Array.isArray(this.props.lastError)
          ? this.props.lastError.map((val, index) => {
              return (
                <span key={index}>
                  {val}
                  <br />
                </span>
              );
            })
          : this.props.lastError;
        return (
          <div className={`alert alert-danger ${this.props.className ?? ""}`}>
            <FormattedMessage id="Saving data failed" />:<br />
            {errString}
          </div>
        );
      } else {
        return (
          <div className={`alert alert-danger ${this.props.className ?? ""}`}>
            <FormattedMessage id="Saving data failed." />
          </div>
        );
      }
    } else {
      // state CLEAN or state EMPTY
      return <></>;
    }
  }
}

const SaveFeedback = connect(mapStateToProps, mapDispatchToProps)(SaveFeedbackComponent);

export default SaveFeedback;
